<template>
    <div>
        <!-- Two File Drawer -->
        <lb-drawer data-testid="transaction-matching-config-new__select-matches-two-file-drawer" :value="comparedialog" @input="$emit('update:comparedialog', $event)" heading="Select Matches" width="1200" :loading="compareloading">
            <template v-slot:body>
                <div>
                    <div>
                        <div data-testid="transaction-matching-config-new__selected-item-label-two-file" class="body-1 my-2">Selected Item : Manual</div>
                        <v-simple-table data-testid="transaction-matching-config-new__selected-item-table-two-file" dense class="border-on mb-4" v-if="twofileselectiteamComparing.length > 0">
                            <template v-slot:default>
                                <thead class="tableHeaderBg">
                                    <tr class="">
                                        <template v-for="(v, k) in twofileselectiteamComparing[0]">
                                            <th data-testid="transaction-matching-config-new__selected-item-header-two-file" :key="k" v-if="k !== '_id'" :id="'automation-test-'+ k" class="ellipsis-on tableHeaderBg" :style="{ 'height': 30 + 'px' }">
                                                {{ (k || "").replaceAll("_", " ") }}
                                            </th>
                                        </template>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr data-testid="transaction-matching-config-new__selected-item-row-two-file" v-for="(v, k) in twofileselectiteamComparing" :key="k" :id="'automation-test-'+k" class="ellipsis-on" :style="{ 'height': 30 + 'px' }">
                                        <template v-for="(vv, kk) in twofileselectiteamComparing[0]">
                                            <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk">
                                                <div v-if="typeof v[kk] === 'number'">
                                                    {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                </div>
                                                <div v-else>
                                                    {{isValidDate(v[kk])}}
                                                </div>
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                   
                    <lb-string data-testid="transaction-matching-config-new__search-input-two-file" :value="searchvalue" @input="$emit('update:searchvalue', $event)" hidedetails label="Search" @change="$emit('filter-two')" />
                    <div data-testid="transaction-matching-config-new__selected-count-two-file" class="body-1 my-2">{{ (selectedids || []).length }} Selected</div>
                    <div class="d-flex">
                        <v-btn data-testid="transaction-matching-config-new__clear-filter-button-two-file" color="primary" class="" @click="$emit('clear-filter-two')" v-if="manualglobaltwofileList.length > 0">
                            <span>Clear Filter</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <div data-testid="transaction-matching-config-new__pagination-two-file" class="radius-on border-on mb-2" v-if="pagecountnewmatchnew > 1 && !loading">
                            <v-btn data-testid="transaction-matching-config-new__pagination-prev-two-file" icon :disabled="pagenewmatchnew === 1" @click="updatePageAndEmit('two', -1)">
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <span class="mx-1">Page {{ pagenewmatchnew }} of {{ pagecountnewmatchnew }}</span>
                            <v-btn data-testid="transaction-matching-config-new__pagination-next-two-file" icon :disabled="pagenewmatchnew === pagecountnewmatchnew" @click="updatePageAndEmit('two', 1)">
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <v-simple-table data-testid="transaction-matching-config-new__matches-table-two-file" dense class="border-on" :fixed-header="true" v-if="formateddataforfilter.length > 0">
                        <template v-slot:default>
                            <thead class="tableHeaderBg">
                                <tr class="">
                                    <th data-testid="transaction-matching-config-new__matches-header-checkbox-two-file" class="tableHeaderBg"></th>
                                    <template v-for="(v, k) in formateddataforfilter[0]">
                                        <th data-testid="transaction-matching-config-new__matches-header-two-file" class="tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+ k">
                                            {{ (k || "").replaceAll("_", " ") }}
                                            <v-btn data-testid="transaction-matching-config-new__matches-filter-button-two-file" class="grey--text text--lighten-1" icon @click="$emit('filter-column-two', k)">
                                                <v-icon>mdi-filter</v-icon>
                                            </v-btn>
                                        </th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <tr data-testid="transaction-matching-config-new__matches-row-two-file" v-for="(v, k) in formateddataforfilter" :key="k">
                                    <td :id="'automation-test-'+ k">
                                        <v-checkbox data-testid="transaction-matching-config-new__matches-checkbox-two-file" :id="'automation-test-'+ k" multiple :value="v[filterselectkey]" hide-details dense :input-value="selectedids" @change="$emit('update:selectedids', $event)" class="ma-0 pa-0"></v-checkbox>
                                    </td>
                                    <template v-for="(vv, kk) in formateddataforfilter[0]">
                                        <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk">
                                            <div v-if="typeof v[kk] === 'number'">
                                                {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                            </div>
                                            <div v-else>
                                                {{isValidDate(v[kk])}}
                                            </div>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                     <div data-testid="transaction-matching-config-new__matches-empty-state-two-file" v-else class="text-center grey--text title pa-6"> No data available </div>
                </div>
            </template>
            <template v-slot:actions>
                <span class="caption">*Required</span>
                <v-spacer></v-spacer>
                <v-btn data-testid="transaction-matching-config-new__match-selected-button-two-file" color="primary" @click="$emit('match-two')" class=""><span>Match Selected</span></v-btn>
            </template>
        </lb-drawer>

        <!-- One File Drawer -->
        <lb-drawer data-testid="transaction-matching-config-new__select-matches-one-file-drawer" :value="comparedialogNew" @input="$emit('update:comparedialogNew', $event)" heading="Select Matches" width="12000" :loading="compareloadingNew">
            <template v-slot:body>
                <div>
                    <div>
                        <div data-testid="transaction-matching-config-new__selected-item-label-one-file" class="body-1 my-2">Selected Item (OneFile):</div>
                        <v-simple-table data-testid="transaction-matching-config-new__selected-item-table-one-file" dense class="mb-4 border-on" v-if="selectiteamComparing.length > 0">
                            <template v-slot:default>
                                <thead class="tableHeaderBg">
                                    <tr class="">
                                        <template v-for="(v, k) in selectiteamComparing[0]">
                                            <th data-testid="transaction-matching-config-new__selected-item-header-one-file" :key="k" v-if="k !== '_id'" :id="'automation-test-'+ k" class="ellipsis-on tableHeaderBg" :style="{ 'height': 30 + 'px' }">
                                                {{ (k || "").replaceAll("_", " ") }}
                                            </th>
                                        </template>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr data-testid="transaction-matching-config-new__selected-item-row-one-file" v-for="(v, k) in selectiteamComparing" :key="k" :id="'automation-test-'+k" class="ellipsis-on" :style="{ 'height': 30 + 'px' }">
                                        <template v-for="(vv, kk) in selectiteamComparing[0]">
                                            <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk">
                                                <div v-if="typeof v[kk] === 'number'">
                                                    {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                </div>
                                                <div v-else>
                                                    {{isValidDate(v[kk])}}
                                                </div>
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                    <lb-string data-testid="transaction-matching-config-new__search-input-one-file" :value="searchvalueNew" @input="$emit('update:searchvalueNew', $event)" hidedetails label="Search" @change="$emit('filter-one')" />
                    <div data-testid="transaction-matching-config-new__selected-count-one-file" class="body-1 my-2">{{ (selectedidsNew || []).length }} Selected</div>
                    <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn data-testid="transaction-matching-config-new__clear-filter-button-one-file" color="primary" class=" mb-2 mr-2" @click="$emit('clear-filter-one')" v-if="manualglobalList.length > 0">
                            <span>Clear Filter</span>
                        </v-btn>
                        <div data-testid="transaction-matching-config-new__pagination-one-file" class="radius-on border-on mb-2" v-if="pagecountnewmatchnew > 1 && !loading">
                            <v-btn data-testid="transaction-matching-config-new__pagination-prev-one-file" icon :disabled="pagenewmatchnew === 1" @click="updatePageAndEmit('one', -1)">
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <span class="mx-1">Page {{ pagenewmatchnew }} of {{ pagecountnewmatchnew }}</span>
                            <v-btn data-testid="transaction-matching-config-new__pagination-next-one-file" icon :disabled="pagenewmatchnew === pagecountnewmatchnew" @click="updatePageAndEmit('one', 1)">
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <v-simple-table data-testid="transaction-matching-config-new__matches-table-one-file" dense class="border-on" :fixed-header="true" v-if="formateddataforfilterNew.length > 0">
                        <template v-slot:default>
                            <thead class="tableHeaderBg">
                                <tr class="">
                                    <th data-testid="transaction-matching-config-new__matches-header-checkbox-one-file" class="tableHeaderBg"></th>
                                    <template v-for="(v, k) in formateddataforfilterNew[0]">
                                        <th data-testid="transaction-matching-config-new__matches-header-one-file" :key="k" v-if="k !== '_id'" :id="'automation-test-'+ k" class="ellipsis-on tableHeaderBg" :style="{ 'height': 30 + 'px' }">
                                            {{ (k || "").replaceAll("_", " ") }}
                                            <v-btn data-testid="transaction-matching-config-new__matches-filter-button-one-file" class="grey--text text--lighten-1" icon @click="$emit('filter-column-one', k)">
                                                <v-icon>mdi-filter</v-icon>
                                            </v-btn>
                                        </th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <tr data-testid="transaction-matching-config-new__matches-row-one-file" v-for="(v, k) in formateddataforfilterNew" :key="k" :id="'automation-test-'+k" class="ellipsis-on" :style="{ 'height': 30 + 'px' }">
                                    <td :id="'automation-test-'+ k">
                                        <v-checkbox data-testid="transaction-matching-config-new__matches-checkbox-one-file" multiple :value="v[filterselectkeyNew]" hide-details dense :input-value="selectedidsNew" @change="$emit('update:selectedidsNew', $event)" class="ma-0 pa-0"></v-checkbox>
                                    </td>
                                    <template v-for="(vv, kk) in formateddataforfilterNew[0]">
                                        <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk">
                                            <div v-if="typeof v[kk] === 'number'">
                                                {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                            </div>
                                            <div v-else>
                                                {{isValidDate(v[kk])}}
                                            </div>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </template>
            <template v-slot:actions>
                <span class="caption">*Required</span>
                <v-spacer></v-spacer>
                <v-btn data-testid="transaction-matching-config-new__match-selected-button-one-file" color="primary" @click="$emit('match-one')" class=""><span>Match Selected</span></v-btn>
             </template>
        </lb-drawer>
    </div>
</template>

<script>
export default {
    name: 'MatchSelectionDrawers',
    props: {
        comparedialog: Boolean,
        comparedialogNew: Boolean,
        compareloading: Boolean,
        compareloadingNew: Boolean,
        twofileselectiteamComparing: {
            type: Array,
            default: () => []
        },
        selectiteamComparing: {
            type: Array,
            default: () => []
        },
        searchvalue: String,
        searchvalueNew: String,
        selectedids: {
            type: Array,
            default: () => []
        },
        selectedidsNew: {
            type: Array,
            default: () => []
        },
        manualglobaltwofileList: {
            type: Array,
            default: () => []
        },
        manualglobalList: {
            type: Array,
            default: () => []
        },
        manualglobalInfotwofile: Object,
        manualglobalInfo: Object,
        pagecountnewmatchnew: {
            type: Number,
            default: 1
        },
        pagenewmatchnew: {
            type: Number,
            default: 1
        },
        loading: Boolean,
        selectcollectiontwofile: [String, Object],
        GlobaleCollectionManual: String,
        formateddataforfilter: {
            type: Array,
            default: () => []
        },
        formateddataforfilterNew: {
            type: Array,
            default: () => []
        },
        filterselectkey: String,
        filterselectkeyNew: String,
        comparingitem: Object,
        comparingitemNew: Object,
        singleglobal: Object,
    },
    methods: {
        isValidDate(value) {
            // Mimicking behavior from SummaryTable.vue - just return value unless strict date formatting is needed
            // If the original component has specific date logic, it should be added here.
            return value;
        },
        updatePageAndEmit(type, change) {
            const newPage = this.pagenewmatchnew + change;
            this.$emit('update:pagenewmatchnew', newPage);
            if (type === 'two') {
                this.$emit('paginate-two', newPage);
            } else {
                this.$emit('paginate-one', newPage);
            }
        }
    }
}
</script>
